import React from "react";
import image1 from "../assets/images/image 1.png";
import image2 from "../assets/images/image2.png";
import image3 from "../assets/images/image3.png";
import pdf from "../assets/pdf.pdf";
import logo from "../assets/images/bricslogo.png";
import bg from "../assets/images/bg.png";
import { Link } from "react-router-dom";
const HomeIndex = () => {
  return (
    <div className="home">
      <div className="container-fluid h-100">
        <div className="logo">
          <img src={logo} />
          <h1>منظومة متابعة الخطة التنفيذية للبريكس</h1>
        </div>
        <div className="cards_wrapper">
          <a href="/login" target="_blank">
            <img src={image1} />
            <h1>نظام متابعة إجراءات البريكس</h1>
          </a>
          <a href="https://shorturl.at/fMQ39" target="_blank">
            <img src={image2} />
            <h1>اللوحة المعلوماتية لمؤشرات تجمع البريكس</h1>
          </a>
          {/* <a href={pdf} download={"اجندة فعاليات بريكس"}>
            <img src={image3} />
            <h1>اجندة فعاليات بريكس </h1>
          </a> */}
          <a href={"/agendaAndlinks"} target="_blank">
            <img src={image3} />
            <h1>اجندة فعاليات البريكس و الروابط الهامة</h1>
          </a>
        </div>
      </div>
    </div>
  );
};
export default HomeIndex;
